import React from 'react';

import { defineMessages } from 'react-intl';
import styled from 'styled-components';

import DefaultLayout from '~/layout/components/DefaultLayout';
import FitAppPageBanner from '~/staticPages/components/FitAppPageBanner';
import FitAppPageEarn from '~/staticPages/components/FitAppPageEarn';
import FitAppPageGoals from '~/staticPages/components/FitAppPageGoals';
import FitAppPageMeet from '~/staticPages/components/FitAppPageMeet';
import FitAppPageMindfulness from '~/staticPages/components/FitAppPageMindfulness';
import FitAppPagePrograms from '~/staticPages/components/FitAppPagePrograms';
import FitAppPageReviews from '~/staticPages/components/FitAppPageReviews';
import FitAppPageWorkouts from '~/staticPages/components/FitAppPageWorkouts';

import createPage from '../registry';

const seo = defineMessages({
  title: {
    id: 'site_seo_title.fitness_app',
    defaultMessage: 'Fitness App',
  },
  description: {
    id: 'site_seo_description.fitness_app',
    defaultMessage: 'Fitness App',
  },
});

const Wrapper = styled.div`
  width: 100%;
  margin: auto;
`;

function FitnessAppPage() {
  return (
    <DefaultLayout title={seo.title} description={seo.description}>
      <Wrapper>
        <FitAppPageBanner />
        <FitAppPageGoals />
        <FitAppPagePrograms />
        <FitAppPageWorkouts />
        <FitAppPageMindfulness />
        <FitAppPageEarn />
        <FitAppPageMeet />
        <FitAppPageReviews />
      </Wrapper>
    </DefaultLayout>
  );
}

export default createPage(FitnessAppPage, {
  resourceBundles: ['fitness_app'],
  prefetchAssets: [
    'fit_page_herobanner_desktop',
    'fitnessapp_content1_desktop',
    'fitnessapp_content2_desktop',
    'fitnessapp_content3_desktop',
    'fitnessapp_content4_desktop',
    'fitnessapp_content5_desktop',
    'fitnessapp_content6_desktop',
    'fitnessapp_content7_desktop',
    'fit_page_herobanner_mobile',
    'fitnessapp_content1_mobile',
    'fitnessapp_content2_mobile',
    'fitnessapp_content3_mobile',
    'fitnessapp_content4_mobile',
    'fitnessapp_content5_mobile',
    'fitnessapp_content6_mobile',
    'fitnessapp_content7_mobile',
  ],
});
